import React from "react";
import { Route, Routes } from "react-router-dom";
import Main from "./Components/Main";
import { PopupProvider } from "./contexts/PopupContext";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <PopupProvider>
      <Routes>
        {/* "/" no longer redirects from here. Which page a path-less request lands on depends on
            the caller's role, and roles are only known once Main has resolved the session — so
            Main owns that decision (see its "/" block). Every other route, deep links included,
            renders the page that was actually asked for and is never rewritten. */}
        <Route path="/" element={<Main />} />
        <Route path="/home" element={<Main />} />
        <Route path="/login" element={<Main />} />
        <Route path="/copilot" element={<Main />} />
        <Route path="/feature-requests" element={<Main />} />
        <Route path="/release-notes" element={<Main />} />
        <Route path="/get-support" element={<Main />} />
        <Route path="/support-tickets" element={<Main />} />
        <Route path="/change-requests" element={<Main />} />
        <Route path="/upgrade-requests" element={<Main />} />
        <Route path="/discover-addons" element={<Main />} />
        <Route path="/resources/knowledge-base" element={<Main />} />
        <Route path="/resources/university" element={<Main />} />
        <Route path="/resources/embed" element={<Main />} />
        <Route path="/profile" element={<Main />} />
        <Route path="/early-adopters" element={<Main />} />
        <Route path="/my-subscription" element={<Main />} />
        <Route path="/copilot-2" element={<Main />} />
        {/* An article is addressed by ?article=<urlname> rather than a path segment, so this one
            route serves both the landing page and the full-size article view. See Main.tsx. */}
        <Route path="/knowledge-base-2" element={<Main />} />
      </Routes>
    </PopupProvider>
  );
}

export default App;
